Ext.define('SA.view.EnableGeographicUnitsFixedSection', {
    alias: 'widget.enable-geographic-units-fixed-section',
    extend: 'Ext.Component',

    cls: 'sa-enable-geographic-units-fixed-section',

    tpl: [
        '<div class="sa-enable-geographic-units-fixed-section-header">Always enabled</div>',
        '<tpl for=".">',
            '<div class="sa-enable-geographic-units-fixed-section-list-item">{name}</div>',
        '</tpl>'
    ],

    initComponent() {
        this.data = SA.data.GeographicUnits.find({units: this.unitIds, includeCountry: true});

        this.callParent();
    }
});